import React from 'react';
import { MdInventory2 } from 'react-icons/md';
import { PaginaDeportes } from '../_shared';
import TablaInventario from './TablaInventario';

const Inventario: React.FC = () => (
  <PaginaDeportes
    icon={MdInventory2}
    titulo="Inventario Deportivo"
    subtitulo="Artículos, existencias, movimientos y resguardos del material deportivo"
  >
    <TablaInventario />
  </PaginaDeportes>
);

export default Inventario;
